import { Theme } from '@mui/material';
import { Colors } from '../../../utils/theme';

export const communityCardStyles = (theme: Theme, backgroundUrl?: string) => ({
	root: {
		display: 'flex',
		flexFlow: 'column nowrap',
		justifyContent: 'flex-end',
		aspectRatio: '1/1.32',
		backgroundImage: `url(${backgroundUrl})`,
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		backgroundColor: 'gray',
		cursor: 'pointer',
		borderRadius: '2px',
		overflow: 'hidden',

		width: '100%',
		minWidth: { xs: '200px', s: '300px', md: '400px', lg: '578px' },
		maxWidth: { xs: '200px', s: '300px', md: '400px', lg: '578px' },

		'&:hover .underlined': {
			textDecoration: 'underline',
			textDecorationColor: Colors['FF6000'],
			textDecorationThickness: '2px',
			textUnderlineOffset: '4px',
		},
	},
	infoSection: {
		px: { xs: '15px', sm: '20px', md: '28px', lg: '35px' },
		pb: { xs: '15px', sm: '20px', md: '28px', lg: '40px' },
		display: 'flex',
		flexFlow: 'column nowrap',
		gap: { xs: '8px', md: '10px', lg: '12px' },
		background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 56.22%, #000000 100%)',
		color: 'white',
		textTransform: 'uppercase',
	},
	titleText: {
		fontFamily: 'Integral CF',
		fontWeight: '700',
		fontSize: { xs: '18px', md: '26px', lg: '32px' },
		lineHeight: '1.2',
		textShadow: '1px 1px 2px black',
	},
	subtitleText: {
		fontFamily: 'Integral CF',
		fontSize: { xs: '12px', md: '14px', lg: '16px' },
		lineHeight: '1.2',
		textShadow: '1px 1px 2px black',
	},
	interestsText: {
		fontFamily: 'Integral CF',
		fontSize: { xs: '12px', md: '14px', lg: '16px' },
		lineHeight: '1.2',
		maxWidth: '100%',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		textShadow: '1px 1px 2px black',
	},
});
